var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":!_vm.isEnabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }